import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type SupplierPurchasableExtraListItem = ResultOf<
  typeof supplierPurchasableExtraList
>["supplierPurchasableExtras"]["data"][number];

export type SupplierPurchasableExtraList = SupplierPurchasableExtraListItem[];
export const supplierPurchasableExtraList = graphql(`
  query SupplierPurchasableExtraList($supplierId: ID!) {
    supplierPurchasableExtras(supplier_id: $supplierId, first: 100) {
      data {
        id
        name
        description
        unit_price
        units_purchasable
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);

export const supplierPurchasableExtra = graphql(`
  query SupplierPurchasableExtra($id: ID!) {
    supplierPurchasableExtra(id: $id) {
      id
      name
      description
      unit_price
      units_purchasable
      image {
        ...MediaFields
      }
    }
  }
`);
